import { render } from "./card-collapsible-hanging.vue?vue&type=template&id=6634561c&ts=true"
import script from "./card-collapsible-hanging.vue?vue&type=script&lang=ts"
export * from "./card-collapsible-hanging.vue?vue&type=script&lang=ts"

import "./card-collapsible-hanging.vue?vue&type=style&index=0&id=6634561c&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__